import React, { useRef, useEffect } from 'react';
import { getLatLng, getEventDate, isOpen } from '../api/eonet';
import './EventList.css';

const MAX_VISIBLE = 100;

export default function EventList({ events, selectedId, onSelectEvent, loading }) {
  const listRef = useRef(null);

  // Scroll selected item into view
  useEffect(() => {
    if (!selectedId || !listRef.current) return;
    const el = listRef.current.querySelector(`[data-id="${selectedId}"]`);
    if (el) el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }, [selectedId]);

  if (loading && events.length === 0) {
    return (
      <div className="event-list">
        <div className="event-empty">Loading wildfire events…</div>
      </div>
    );
  }

  if (!loading && events.length === 0) {
    return (
      <div className="event-list">
        <div className="event-empty">No events match your filters.</div>
      </div>
    );
  }

  const visible = events.slice(0, MAX_VISIBLE);

  return (
    <div className="event-list" ref={listRef}>
      {visible.map(event => (
        <EventRow
          key={event.id}
          event={event}
          selected={event.id === selectedId}
          onClick={() => onSelectEvent(event.id)}
        />
      ))}
      {events.length > MAX_VISIBLE && (
        <div className="event-overflow">
          Showing {MAX_VISIBLE} of {events.length} events · Refine search to narrow results
        </div>
      )}
    </div>
  );
}

function EventRow({ event, selected, onClick }) {
  const open = isOpen(event);
  const coords = getLatLng(event);
  const dateStr = getEventDate(event);
  const source = event.sources?.[0]?.id || '';

  return (
    <div
      className={`event-row ${selected ? 'selected' : ''}`}
      data-id={event.id}
      onClick={onClick}
    >
      <div
        className="event-dot"
        style={{ background: open ? '#D85A30' : '#5F5E5A' }}
      />
      <div className="event-body">
        <div className="event-title">
          {event.title}
          <span className={`event-badge ${open ? 'badge-open' : 'badge-closed'}`}>
            {open ? 'ACTIVE' : 'RESOLVED'}
          </span>
        </div>
        <div className="event-meta">
          {dateStr}
          {source && <span className="event-source"> · {source}</span>}
        </div>
        {coords && (
          <div className="event-coords">
            {coords[0].toFixed(3)}°, {coords[1].toFixed(3)}°
          </div>
        )}
      </div>
      <div className="event-arrow">›</div>
    </div>
  );
}
